import(/* webpackMode: "eager" */ "/opt/build/repo/src/app/renovation-budget-calculator/page.tsx");
